"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemas = schemas;
exports.schema = schema;
exports.assertParse = assertParse;
exports.isParse = isParse;
exports.validateParse = validateParse;
exports.stringify = stringify;
exports.assertStringify = assertStringify;
exports.isStringify = isStringify;
exports.validateStringify = validateStringify;
exports.createIsParse = createIsParse;
exports.createAssertParse = createAssertParse;
exports.createValidateParse = createValidateParse;
exports.createStringify = createStringify;
exports.createAssertStringify = createAssertStringify;
exports.createIsStringify = createIsStringify;
exports.createValidateStringify = createValidateStringify;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function schemas() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.schemas");
}
/** @internal */
function schema() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.schema");
}
/** @internal */
function assertParse() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.assertParse");
}
/** @internal */
function isParse() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.isParse");
}
/** @internal */
function validateParse() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.validateParse");
}
/** @internal */
function stringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.stringify");
}
/** @internal */
function assertStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.assertStringify");
}
/** @internal */
function isStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.isStringify");
}
/** @internal */
function validateStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.validateStringify");
}
/** @internal */
function createIsParse() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createIsParse");
}
/** @internal */
function createAssertParse() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createAssertParse");
}
/** @internal */
function createValidateParse() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createValidateParse");
}
/** @internal */
function createStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createStringify");
}
/** @internal */
function createAssertStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createAssertStringify");
}
/** @internal */
function createIsStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createIsStringify");
}
/** @internal */
function createValidateStringify() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("json.createValidateStringify");
}
//# sourceMappingURL=json.js.map